import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { isAppLocale, LOCALE_TO_AI_TRIP_IFRAME_LANG } from '@/constants/appLocale';

const AI_TRIP_IFRAME_ORIGIN = 'https://lc-xc.cookieboty.tech/';

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

/** 解析整数查询参数，不合法则返回 null */
const parseIntParam = (value: string | null, min: number, max?: number) => {
  if (!value) return null;
  const n = Number(value);
  if (!Number.isInteger(n) || n < min) return null;
  if (max !== undefined && n > max) return null;
  return String(n);
};

const AITrip = () => {
  const { i18n } = useTranslation();
  const [searchParams] = useSearchParams();

  const iframeSrc = useMemo(() => {
    const locale = isAppLocale(i18n.language) ? i18n.language : 'zh_CN';
    const lang = LOCALE_TO_AI_TRIP_IFRAME_LANG[locale];
    const url = new URL(AI_TRIP_IFRAME_ORIGIN);
    url.searchParams.set('lang', lang);

    const departureDate = searchParams.get('departureDate');
    if (departureDate && DATE_RE.test(departureDate)) {
      url.searchParams.set('departureDate', departureDate);
    }

    // returnDate 与 days 二选一，优先 returnDate
    const returnDate = searchParams.get('returnDate');
    if (returnDate && DATE_RE.test(returnDate)) {
      url.searchParams.set('returnDate', returnDate);
    } else {
      const days = parseIntParam(searchParams.get('days'), 1);
      if (days) url.searchParams.set('days', days);
    }

    const people = parseIntParam(searchParams.get('people'), 1, 10);
    if (people) url.searchParams.set('people', people);

    const budget = parseIntParam(searchParams.get('budget'), 1000);
    if (budget) url.searchParams.set('budget', budget);

    return url.toString();
  }, [i18n.language, searchParams]);

  return (
    <div className="w-full">
      <iframe
        key={iframeSrc}
        className="w-full"
        style={{ minHeight: 400, border: 0, height: '100vh' }}
        src={iframeSrc}
        title="AI Trip"
      />
    </div>
  );
};

export default AITrip;
